import UserLoading from 'publicContainer/Loading';
import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader } from 'zComponents/atoms';
import { Flex } from 'zui/Antd';
import ErrorBoundary from './ErrorBoundary';
import RouteRenderer from './routeRenderer';
import { DASHBOARD_ROUTES, PUBLIC_ROUTES } from './routes';
import SocketManager from 'library/helpers/socketManager';

const FourZeroFour = lazy(() => import('publicContainer/404'));

const Navigation = () => {
	const userLoadingComplete = useSelector((state) => state.App.userLoadingComplete);
	const { isLoggedIn, loginLoading, selectedProfile: person } = useSelector((state) => state.Auth);

	// Show a full-page loader while the initial auth check is resolving
	// (e.g. cross-origin token exchange from Rooms Dashboard)
	if (loginLoading && !isLoggedIn) {
		return (
			<Flex
				style={{
					height: '100vh'
				}}
			>
				<Loader subTitle='Authenticating...' />
			</Flex>
		);
	}

	return (
		<ErrorBoundary>
			<Suspense fallback={<Loader />}>
				<BrowserRouter
					future={{
						v7_startTransition: true,
						v7_relativeSplatPath: true
					}}
				>
					{isLoggedIn && <SocketManager />}
					<Routes>
						<Route path='/'>
							{PUBLIC_ROUTES.map((route, index) => (
								<Route path={route.path} key={index} element={<route.component />} />
							))}
						</Route>
						{/* If the user's resources are loading finished then render the restricted content.
							//? this also checks for the the user is logged in or not, if not then redirect to signin page.
						 */}
						{!userLoadingComplete && isLoggedIn ? (
							<Route path='*' element={<UserLoading />} />
						) : (
							<Route element={!isLoggedIn && <Navigate to={'signin'} replace />}>
								{DASHBOARD_ROUTES.map((route, index) => (
									<Route path={route.path} key={index} element={<route.component />}>
										{RouteRenderer({ person, routesList: route.routes })}
									</Route>
								))}
							</Route>
						)}

						{/* If the route reaches here then show the 404 screen as the path didn't mach any route. */}
						<Route path='/*' key={'404'} element={<FourZeroFour />} />
					</Routes>
				</BrowserRouter>
			</Suspense>
		</ErrorBoundary>
	);
};

export default Navigation;
